import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Slide,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/material";
import React from "react";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const list = [
  {
    key: 0,
    title: "GemX Chat",
    combination: [ "Shift", "U"],
  },
  {
    key: 1,
    title: "Voice Call",
    combination: ["Ctrl", "m"],
  },
  {
    key: 2,
    title: "Video Call",
    combination: ["Ctrl",  "e"],
  },
  {
    key: 3,
    title: "Profile",
    combination: ["Ctrl", "Shift", "D"],
  },
   {
    key: 4,
    title: "Home",
    combination: ["Ctrl", "Shift", "P"],
  }, 
  {
    key: 5,
    title: "Chat SideBar",
    combination: ["Ctrl", "Shift", "F"],
  },
   {
    key: 6,
    title: "Sign Out",
    combination: ["Ctrl", "f"],
  },
  {
    key: 7,
    title: "Settings",
    combination: ["Ctrl","Shift" , "K"],
  },
  /*{
    key: 8,
    title: "Sticker Panel",
    combination: ["Ctrl", "Tab"],
  },
  {
    key: 9,
    title: "Mute",
    combination: ["Ctrl", "Shift", "Tab"],
  },
  {
    key: 10,
    title: "Delete Chat",
    combination: ["Cmd", "Shift", "N"],
  },
  {
    key: 11,
    title: "Search",
    combination: ["Cmd", "P"],
  },
  {
    key: 12,
    title: "New Chat",
    combination: ["Shift", "."],
  },
  {
    key: 13,
    title: "Previous Chat",
    combination: ["Shift", ","],
  },
  {
    key: 14,
    title: "Profile & About",
    combination: ["Shift", "S"],
  },
  {
    key: 15,
    title: "Decrease Speed Of Voice Message",
    combination: ["Cmd", "E"],
  },
  {
    key: 16,
    title: "EmojiPanel",
    combination: ["Cmd", "S"],
  }, */
];
function Shortcuts({ open, handleClose }) {
  return (
    <>
      <Dialog
       className="shortcut"
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleClose}
        keepMounted
        TransitionComponent={Transition}
        sx={{ p: 4,position: 'absolute'}}
      >
        <DialogTitle >KeyBoard Shortcuts</DialogTitle>
        <DialogContent sx={{ mt: 4}} >
          <Grid container spacing={3} >
            {list.map(({ key, title, combination }) => (
              <>
                <Grid key={key} container item xs={8} >
                  <Stack
                    sx={{ width: "100%" }}
                    justifyContent="space-between"
                    spacing={3}
                    direction="row"
                    alignItems={"center"}
                  >
                    <Typography variant="caption" sx={{ fontSize: 14 }}>
                      {" "}
                      {title}
                    </Typography>
                    <Stack spacing={2} direction="row">
                        {combination.map((el)=>{
                            return<Button disabled variant = "contained" sx={{color:"#212121"}}>{el}</Button>
                        })}
                    </Stack>
                  </Stack>
                </Grid>
              </>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
            <Button variant="contained" onClick={handleClose}>OK</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Shortcuts;
